import moment from 'moment-timezone';
import { ICastingRoleAttributes } from 'shared/interfaces/ICastingRole';
import { IRoleAttributes } from 'shared/interfaces/IRole';
import { arrayToParagraphShortener } from 'shared/utils';

export const useHeaderContentParser = (role: IRoleAttributes | ICastingRoleAttributes) => {
  const {
    name,
    submission_date_due,
    working,
    fitting,
    age_range_from,
    age_range_to,
    age_range_type,
    genders,
    ethnic_appearance,
    talent_description: description,
    mediumable_count,
    rate_summary,
    self_tapes_requirements,
  } = role;
  const { dates, location: workingLocation, note } = working ? working : { dates: [], location: '', note: '' };
  const { dates: fitDates } = fitting ? fitting : { dates: [] };

  const convertDate = (date: Date) => moment(date).format('MM/DD/YY, h:mm A');

  const roleName = name;
  const union = ' No Union Affilitaion - static';
  const rate = rate_summary ? rate_summary : '-';
  const submitBy = submission_date_due ? convertDate(submission_date_due) : '-';
  const talentSubmitBy = self_tapes_requirements
    ? moment(self_tapes_requirements.date).format('DD MMM YYYY') + ', ' + self_tapes_requirements.time
    : '-';
  const work = dates?.length ? dates[0] : '-';
  const fittingDate = fitDates?.length ? fitDates[0] : '-';
  const age = age_range_from && age_range_to ? `${age_range_from} - ${age_range_to}` : '-';
  const ageType = age_range_type === 'Month' ? ' (Months)' : '';
  const gender = arrayToParagraphShortener({ lists: genders });
  const ethnicities = arrayToParagraphShortener({ lists: ethnic_appearance });
  const location = workingLocation ? workingLocation : '-';
  const roleDescription = description ? description : '-';
  const workingNote = note ? note : '-';
  const roleMediaCount = mediumable_count || 0;

  return {
    ageType,
    roleName,
    union,
    rate,
    submitBy,
    work,
    fittingDate,
    age,
    gender,
    ethnicities,
    location,
    roleDescription,
    roleMediaCount,
    workingNote,
    ethnic_appearance,
    genders,
    talentSubmitBy,
  };
};
